import React from "react";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import PremiumHeader from "components/PremiumLanding/PremiumHeader";
import PremiumFooter from "components/PremiumLanding/PremiumFooter";
import "components/PremiumLanding/PremiumLanding.css";

export default function AboutUs() {
  const { t, i18n } = useTranslation();
  const auth = useSelector((state) => state.auth);
  const settings = useSelector((state) => state.settingsdata.settings) || {};
  const isRTL = i18n.dir() === "rtl";

  return (
    <div className="premium-landing premium-public-page" dir={isRTL ? "rtl" : "ltr"}>
      <Helmet>
        <title>{t("about_us")} | Garahex</title>
        <meta name="description" content={t("about_us_content2")} />
      </Helmet>
      <a className="pl-skip-link" href="#pl-main-content">Skip to content</a>
      <PremiumHeader isLoggedIn={Boolean(auth && auth.profile && auth.profile.uid)} />

      <main id="pl-main-content" className="pl-public-main">
        <section className="pl-public-hero">
          <div className="pl-public-hero__glow" aria-hidden="true" />
          <div className="pl-container pl-public-hero__inner">
            <div className="pl-public-hero__copy pl-reveal is-visible">
              <p className="pl-eyebrow pl-eyebrow--light">ABOUT GARAHEX</p>
              <h1>{t("about_us")}</h1>
              <p>{t("about_us_content2")}</p>
            </div>
            <div className="pl-public-hero__panel" aria-hidden="true">
              <span><LocalShippingRoundedIcon /></span>
              <strong>GARAHEX</strong>
            </div>
          </div>
        </section>

        <section className="pl-public-section">
          <div className="pl-container">
            <div className="pl-public-contentGrid">
              <article className="pl-public-card pl-public-card--story">
                <p className="pl-eyebrow">Our Story</p>
                <h2>{t("about_us")}</h2>
                <p>{t("about_us_content2")}</p>
                <p>{t("about_us_content1")}</p>
              </article>

              <aside className="pl-public-card pl-public-accentCard" aria-hidden="true">
                <div>
                  <VerifiedRoundedIcon aria-hidden="true" />
                </div>
                <div>
                  <LocalShippingRoundedIcon aria-hidden="true" />
                </div>
                <div>
                  <PublicRoundedIcon aria-hidden="true" />
                </div>
              </aside>
            </div>
          </div>
        </section>
      </main>

      <PremiumFooter settings={settings} />
    </div>
  );
}
